import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { IMessage } from '../success-snack-bar/success-snack-bar.component';

@Component({
  selector: 'app-info-snack-bar',
  imports: [MatIcon],
  templateUrl: './info-snack-bar.component.html',
})
export class InfoSnackBarComponent {
  data = inject<IMessage>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef =
    inject<MatSnackBarRef<InfoSnackBarComponent>>(MatSnackBarRef);

  dismissSnackBar() {
    this.snackBarRef.dismiss();
  }
}
